import injectMultipleBanners from './inject-multiple-banners';
export default injectMultipleBanners;
//# sourceMappingURL=index.js.map